import moment from 'moment'

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_HUMAN_FORMAT = 'M/D/YYYY'
export const DATE_INPUT_FORMAT = 'MM/DD/YYYY'
export const DATE_MONTH_NAME_FORMAT = 'MMM D YYYY'

export function formatDateHuman(date: string) {
  return moment(date, DATE_FORMAT, true).format(DATE_HUMAN_FORMAT)
}

export function formatDateMonthName(date: string | moment.Moment) {
  return moment(date, DATE_FORMAT, true).format(DATE_MONTH_NAME_FORMAT)
}

export function formatInputDateToHuman(date: string) {
  return moment(date, DATE_INPUT_FORMAT, true).format(DATE_HUMAN_FORMAT)
}
